import {DisplayDynamicTable} from '@/containers'
import {PageContainer} from '@/components/organisms'
import {PageHeader} from 'pepsico-ds'
import {useState} from 'react'
import {Tab, TabsNavigation} from '@/components/atoms'

export const DynamicTable = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title="Data Table" />
      </div>
      <PageContainer data-testid="online-order-page-content">
        <DynamicTableEmbeddedInNavigation />
      </PageContainer>
    </div>
  )
}

const DynamicTableEmbeddedInNavigation = () => {
  const [selectedTabIndex, setSelectedIndex] = useState(0)
  const handleNavigationUpdate = newIndex => {
    setSelectedIndex(newIndex)
  }

  return (
    <>
      <TabsNavigation handleSetActiveTab={handleNavigationUpdate} activeTabIndex={selectedTabIndex} className="mb-5">
        <Tab className="text-white" label="Dynamic" />
      </TabsNavigation>
      <DisplayDynamicTable />
    </>
  )
}
